export const PERSON_ALERTS = [
  {title: 'High Impact', value: 'high', icon: 'message-alert-square'},
  {title: 'Everything', value: 'all', icon: 'message-check-square'},
  {title: 'None', value: 'none', icon: 'message-x-square'},
]

export const COMPANY_ALERTS = [
  {title: 'High Impact', value: 'high', icon: 'message-alert-square'},
  {title: 'Everything', value: 'all', icon: 'message-check-square'},
  {title: 'None', value: 'none', icon: 'message-x-square'},
]

export const COMPANY_TYPES = [
  {title: 'Prospect', value: 'prospect', icon: 'target'},
  {title: 'Account', value: 'account', icon: 'building-2'},
  {title: 'Competitor', value: 'competitor', icon: 'flag'},
]

export const TOPIC_SENSITIVITY = [
  {title: 'High Impact', value: 'high', icon: 'target-s'},
  {title: 'Balanced', value: 'balanced', icon: 'target-m'},
  {title: 'All Signals', value: 'all', icon: 'target-l'}
]

export const TOPIC_ALERTS = [
  {title: 'High Impact', value: 'high', icon: 'message-alert-square'},
  {title: 'Everything', value: 'all', icon: 'message-check-square'},
  {title: 'None', value: 'none', icon: 'message-x-square'},
]
